G.ActionBoosterMatch = function(board,am,args) {

  G.Action.call(this,board,am,args);
  
	this.clickedCandy = false;
	this.availableCandies = [];

	this.inputController = this.board.inputController;

	this.signalBinding = game.input.onDown.add(function(pointer) {

		var cell = this.inputController.pointerToCell(pointer);
    if (!cell) return;

    var cellX = cell[0];
    var cellY = cell[1];

    var candy = this.board.getCandy(cellX, cellY);
    var tokens = this.board.getAllTokensInCell(cellX, cellY);
    if (candy) {
      if ((this.availableCandies.length > 0 && 
        this.availableCandies.indexOf(candy) === -1) ||
        ((tokens.length == 1 || tokens[0] == candy)
        && (candy.baseType.getEditorSymbol() === "lc"
          || candy.isGoalCandy()
          || candy.isBurntCandy()))) {
        return;
      } else {
        this._triggerBooster(cellX, cellY, this.args[0]);
      }
    } else {
      if (tokens.length > 0) {
        const isLegalMove = this.availableCandies.length > 0
          ? tokens.reduce((legal, token) => this.availableCandies.indexOf(token) !== -1 || legal, false)
          : true;

        if (isLegalMove) {
          this._triggerBooster(cellX, cellY, this.args[0]);
        }
      }
    }

	},this);

	this.boosterInit = false;

   
};

G.ActionBoosterMatch.prototype = Object.create(G.Action.prototype);

G.ActionBoosterMatch.prototype.update = function() {

};

G.ActionBoosterMatch.prototype._triggerBooster = function(cellX, cellY, boosterData) {
  const boosterNr = boosterData.boosterNr;
  const unlimitedMode = boosterData.unlimitedMode;
  G.sfx.pop.play()
  G.saveState.useBooster(boosterNr, G.lvl.lvlIndex, unlimitedMode);
  G.lvl.onBoosterUse(boosterNr);
  this.signalBinding.detach();
  if (boosterNr == 3) {
    this.board.boardCandies.boosterFxGroup.add(new G.BoosterHorizontal(cellX,cellY,boosterNr));
  }else if (boosterNr == 4) {
    this.board.boardCandies.boosterFxGroup.add(new G.BoosterVertical(cellX,cellY,boosterNr));
  }else {
    this.board.boardCandies.boosterFxGroup.add(new G.Booster(cellX,cellY,boosterNr));
  }
}


G.ActionBoosterMatch.prototype.finish = function() {
	this.signalBinding.detach();
	this.am.removeAction(this);
};





G.ActionBoosterSwap = function(board,am,args) {

  G.Action.call(this,board,am,args);

  this.availableCandies = [];

  this.clickedCandy = false;
  this.clickedCandy2 = false;
  this.madeMove = false;

  this.inputController = this.board.inputController;

  const boosterNr = this.args[0].boosterNr;
  const unlimitedMode = this.args[0].unlimitedMode;

  this.signalBinding = game.input.onDown.add(function(pointer) {

    var cell = this.inputController.pointerToCell(pointer);
    if (cell) {
      if (this.board.isMoveable(cell[0],cell[1])) {
        
        var candy = this.board.getCandy(cell[0],cell[1]);
        if (candy.isGoalCandy() || candy.isBurntCandy()) return;

        if (!this.clickedCandy && (this.availableCandies.length == 0 || this.availableCandies.indexOf(candy) != -1)) {
          this.selection = this.board.candySelection;
          this.selection.selectCandy(candy);
          G.sb("onBoosterSwapCandySelect").dispatch(candy);
          return this.clickedCandy = candy; 
        }

        if (this.clickedCandy != candy && (this.availableCandies.length == 0 || this.availableCandies.indexOf(candy) != -1)) {
          if (G.lvl.tutOpen) {
            var tut = game.state.getCurrentState().tut;
            game.add.tween(tut.hand).to({alpha:0},300,Phaser.Easing.Sinusoidal.In,true);
          }
          this.clickedCandy2 = candy;
          G.saveState.useBooster(1, G.lvl.lvlIndex, unlimitedMode);
          G.lvl.onBoosterUse(1);
        }
      }
    }

  },this);
   
};

G.ActionBoosterSwap.prototype = Object.create(G.Action.prototype);

G.ActionBoosterSwap.prototype.update = function() {

  if (!this.clickedCandy || !this.clickedCandy2) return;


  if (!this.madeMove) {
    this.madeMove = true;
    this.signalBinding.detach();
    if (this.selection) this.selection.hide();
    this.clickedCandy2.moveTo(this.clickedCandy.cellX,this.clickedCandy.cellY);
    this.clickedCandy.moveTo(this.clickedCandy2.cellX,this.clickedCandy2.cellY,true);
  }


  if (!this.board.duringAnimation && !this.board.duringFall) {

      if (this.board.matcher.isMoveValid(this.clickedCandy)) this.board.checkMatchList.push(this.clickedCandy);
      if (this.board.matcher.isMoveValid(this.clickedCandy2)) this.board.checkMatchList.push(this.clickedCandy2);
      this.clickedCandy.markSuccessfulMove();
      this.clickedCandy2.markSuccessfulMove();

      if (this.board.checkMatchList.length > 0) {
        this.am.newAction('processMatch');
      }
      this.am.newAction('processFall');

      G.sb("onBoosterActionFinished").dispatch();
      this.finish();

  }


};


G.ActionBoosterSwap.prototype.finish = function() {

  if (this.selection) this.selection.hide();

  this.signalBinding.detach();
  this.am.removeAction(this);

};